module.exports = __webpack_public_path__ + "img/T6-B-11.227e252f.png";